const React = require("react");
const T = React.PropTypes;
const moment = require("moment");

const WalkThruType = require("~/types/WalkThru.js").PropType;
const ErrorType = require("~/types/Error.js").PropType;
const walkThruLoadDispatchers = require("~/events/walkThruLoad/walkThruLoadDispatchers.js");

const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const MajorError = require("../MajorError/MajorError.jsx");

require("./WalkThru.less");

const WalkThru = React.createClass({
    propTypes: {
        WalkThru: WalkThruType
    },
    componentWillMount() {
        if (this.props.WalkThru.Data === null) {
            walkThruLoadDispatchers.LoadWalkThru(
                this.props.WalkThru.SurveyType,
                this.props.WalkThru.SurveyFacilityNumber,
                this.props.WalkThru.SurveyID);
        }
    },
    componentWillReceiveProps(newProps) {
        if (!newProps.WalkThru.LoadError
            && !newProps.WalkThru.IsLoading) {
            if (this.props.WalkThru.SurveyID !== newProps.WalkThru.SurveyID) {
                walkThruLoadDispatchers.LoadWalkThru(
                    newProps.WalkThru.SurveyType,
                    newProps.WalkThru.SurveyFacilityNumber,
                    newProps.WalkThru.SurveyID);
            }
        }
    },
    render() {
        let message = this.GetMessage();

        if (message) {
            return (<MajorMessage>
                {message}
            </MajorMessage>);
        }

        const heading = this.GetHeading();
        const entries = this.GetEntries();

        return (<div className="cs-WalkThru">
            <h2>
                Walk Thru List
            </h2>
            {heading}
            {entries}
        </div>);
    },
    GetMessage() {
        if (this.props.WalkThru.LoadError) {
            return (<div className="cs-WalkThru__load-error">
                <h2>
                    There was a problem loading the walk thru.
                </h2>
                <h3>
                    First thing to do is try reloading this page.
                </h3>
                <h3>
                    If that doesn't work, please contact Support Services.
                </h3>
                <MajorError Error={this.props.WalkThru.LoadError } />
            </div>);
        }

        if (this.props.WalkThru.IsLoading) {
            return (<MajorLoading />);
        }

        return null;
    },
    GetHeading() {
        if (!this.props.WalkThru.Data) return null;
        
        const created = moment(this.props.WalkThru.Data.Created)
            .format("MM/DD/YYYY h:mm:ss A");

        return (<table className="cs-WalkThru__heading-table">
            <tbody>
                <tr>
                    <td>
                        <label className="cs-WalkThru__heading-label">
                            Org./Site #:
                        </label>
                        <span className="cs-WalkThru__heading-text">
                            {this.props.WalkThru.Data.FacNumber}
                        </span>
                        <span className="cs-WalkThru__heading-text">
                            {this.props.WalkThru.Data.FacName}
                        </span>
                    </td>
                    <td rowSpan="2">
                        <label className="cs-WalkThru__heading-label">
                            Info:
                        </label>
                        <div className="cs-WalkThru__heading-text">
                            <p className="cs-WalkThru__heading-em">
                                O = Overlocked, PO = Pending Overlock, PR = Pending Removal
                            </p>
                            <p className="cs-WalkThru__heading-em">
                                Reserved = Hard Reservation
                            </p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label className="cs-WalkThru__heading-label">
                            Generated:
                        </label>
                        <span className="cs-WalkThru__heading-text">
                            {created}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>);
    },
    GetEntries() {
        if (!this.props.WalkThru.Data) return null;

        const rows = this.props.WalkThru.Data.Entries.map(this.MakeRow);

        return (<table className="cs-WalkThru__entries-table">
            <thead>
                <tr>
                    <th className="cs-WalkThru__entries-table__th">Cube</th>
                    <th className="cs-WalkThru__entries-table__th">Status</th>
                    <th className="cs-WalkThru__entries-table__th">Dim</th>
                    <th className="cs-WalkThru__entries-table__th">Attr</th>
                    <th className="cs-WalkThru__entries-table__th">Account</th>
                    <th className="cs-WalkThru__entries-table__th">Rental Start</th>
                    <th className="cs-WalkThru__entries-table__th">PTD</th>
                    <th className="cs-WalkThru__entries-table__th">Rent Rate</th>
                    <th className="cs-WalkThru__entries-table__th">Del. Step</th>
                    <th className="cs-WalkThru__entries-table__th">Days Late</th>
                    <th className="cs-WalkThru__entries-table__th">O. Lk.</th>
                </tr>
            </thead>
            <tbody className="cs-WalkThru__entries-table__tbody">
                {rows}  
            </tbody>
        </table>);
    },
    MakeRow(vals, i) {
        const cube = vals[0];
        const status = vals[1];
        const dim = vals[2];
        const attr = vals[3];
        const acct = vals[4];
        const rentalStart = vals[5].split(' ')[0];
        const ptd = vals[6].split(' ')[0];
        const rentRate = parseFloat(vals[7]).toFixed(2);
        const delStep = vals[8];
        const daysLate = vals[9];
        const overlock = vals[10];

        return (<tr key={i} className="cs-WalkThru__entries-table__tr">
            <td className="cs-WalkThru__entries-table__td">{cube}</td>
            <td className="cs-WalkThru__entries-table__td-odd">{status}</td>
            <td className="cs-WalkThru__entries-table__td">{dim}</td>
            <td className="cs-WalkThru__entries-table__td-odd">{attr}</td>
            <td className="cs-WalkThru__entries-table__td">{acct}</td>
            <td className="cs-WalkThru__entries-table__td-odd-right">{rentalStart}</td>
            <td className="cs-WalkThru__entries-table__td-right">{ptd}</td>
            <td className="cs-WalkThru__entries-table__td-odd-right">{rentRate}</td>
            <td className="cs-WalkThru__entries-table__td-right">{delStep}</td>
            <td className="cs-WalkThru__entries-table__td-odd-right">{daysLate}</td>
            <td className="cs-WalkThru__entries-table__td">{overlock}</td>
        </tr>);
    }
});

module.exports = WalkThru;


// WEBPACK FOOTER //
// ./src/components/WalkThru/WalkThru.jsx